import {Action} from '@ngrx/store';
import {User} from '../../users/user';

export const LOAD_USER = '[Auth] Load User';
export const LOAD_USER_SUCCESS = '[Auth] Load User Success';
export const LOGIN_USER = '[Auth] Login User';
export const LOGOUT_USER = '[Auth] Logout User';
export const LOGIN_USER_SUCCESS = '[Auth] Login User Success';
export const LOGIN_USER_FAIL = '[Auth] Login User Fail';
export const NOT_AUTHENTICATED = '[Auth] Not Authenticated';

export class LoginUser implements Action {
  readonly type = LOGIN_USER;

  constructor(public payload: any) {
  }
}

export class LoadUser implements Action {
  readonly type = LOAD_USER;
}

export class LoadUserSuccess implements Action {
  readonly type = LOAD_USER_SUCCESS;

  constructor(public payload: any) {
  }
}

export class LoginUserFail implements Action {
  readonly type = LOGIN_USER_FAIL;

  constructor(public payload: any) {
  }
}

export class UserNotAuthenticated implements Action {
  readonly type = NOT_AUTHENTICATED;
}

export class LogoutUser implements Action {
  readonly type = LOGOUT_USER;
}


export class LoginUserSuccess implements Action {
  readonly type = LOGIN_USER_SUCCESS;

  constructor(public payload: User) {
  }
}


export type UserActions =
  LoadUser
  | LoadUserSuccess
  | LoginUserSuccess
  | LoginUserFail
  | LoginUser
  | UserNotAuthenticated
  | LogoutUser;



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/store/actions/auth.actions.ts